function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 18V6.80002L10 2.00002L2 6.80002V18H6V14.918C6 13.8572 6.42143 12.8397 7.17157 12.0896C7.92172 11.3394 8.93913 10.918 10 10.918C11.0609 10.918 12.0783 11.3394 12.8284 12.0896C13.5786 12.8397 14 13.8572 14 14.918V18H18ZM12 20V14.918C12 14.3876 11.7893 13.8789 11.4142 13.5038C11.0391 13.1287 10.5304 12.918 10 12.918C9.46957 12.918 8.96086 13.1287 8.58579 13.5038C8.21071 13.8789 8 14.3876 8 14.918V20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18L0 6.80002C-3.32274e-06 6.45465 0.0894306 6.11516 0.259593 5.81462C0.429755 5.51407 0.674847 5.26271 0.971 5.08502L8.971 0.285019C9.28183 0.0985175 9.63751 0 10 0C10.3625 0 10.7182 0.0985175 11.029 0.285019L19.029 5.08502C19.3252 5.26271 19.5702 5.51407 19.7404 5.81462C19.9106 6.11516 20 6.45465 20 6.80002V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H12Z",
  fill: "currentColor"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cddfeea5.svg";
export { ForwardRef as ReactComponent };